<template>
  <div class="main-content-wrapper">
  
      <AppNewHeader
        style="width: 100%"
        :userName="userName"
        :placeholderText="'搜索知识资源'"
      />
    <!-- </div> -->
    <div class="main-conter">
      <div class="content_box_header">
        <div class="search_container_header" :style="headerStyle">
            <p> {{bannerValue}} </p>
          </div>
      </div>
      
      <!-- 顶部盒子 -->
      <!-- 包裹除头部和底部外的内容 -->
      <div class="content_box">
        <!-- <KnowledgeIndex
          :knowledgeconter="knowledgeCards2"
          :activeNav="activeNav2"
          :keywordIndex="keyWordIndex"
          :knowData="dataList"
        ></KnowledgeIndex> -->
          <NewLicationList
          :knowledgeconter="knowledgeCards2"
          :activeNav="activeNav2"
          :keywordIndex="keyWordIndex"
          :knowData="dataList"
        ></NewLicationList>
      </div>
    </div>
    <el-footer>
      <AppFooter></AppFooter>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted,computed  } from "vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppFooter from "@/views/components/AppFooter.vue";
// import KnowledgeIndex from "@/views/components/knowledgeindex.vue";
import NewLicationList from "@/views/components/NewLicationList.vue";
import { fetchResourceNavi, PostselectKnowledgeBaseList } from "@/api/index.js";
import bannerzfbm from '@/assets/yylyimages/zfbmbanner.png'
import kydwbanner from '@/assets/yylyimages/kydwbanner.png'
import ggtsgbanner from '@/assets/yylyimages/ggtsgbanner.png'
import gxtsgimg from '@/assets/yylyimages/gxtsgimg.png'
import { Search } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";

import bus from "@/mitt/bus.js";
const searchQuery = ref("");
const currentPage = ref(1);
import { Cookie } from "@/utils/Cookie";
const knowledgeCards2 = ref([]);
const dataList = ref([]);
const keyWordIndex = ref("");
const bannerValue = ref("通过个性化定制数字政府解决方案，切实推动网络强国和数字中国战略落地实施");
// const activeNav2 = ref("智汇三农");
const input2 = ref("");
const router = useRouter();
const route = useRoute();
const bgImages = {
  '396': bannerzfbm,
  '397': kydwbanner,
  '398': ggtsgbanner,
  '399': gxtsgimg
};
const currentBg = ref(null);

const headerStyle = computed(() => {
  return {
    // backgroundImage:getImagePath2( currentBg.value ? `url(${currentBg.value})` : 'none'),
    backgroundImage:currentBg.value ? `url(${currentBg.value})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };
});
const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};

bus.on("yyluid", (data) => {
  // 根据data值设置对应的背景图
  if (bgImages[data.data]) {
    currentBg.value = bgImages[data.data];
  } else {
    console.warn(`未定义data=${data.data}对应的背景图`);
    currentBg.value = null; // 或者设置一个默认背景
  }

  if(data.data === '396'){
    bannerValue.value = '通过个性化定制数字政府解决方案，切实推动网络强国和数字中国战略落地实施'
  }else if(data.data === '397'){
 bannerValue.value = "强大、智能、开放的知识库，全面赋能科研训练与人才培养"
  }else if(data.data === '398'){
     bannerValue.value = "便捷的文化资讯、电子阅览，打造新一代智慧图书馆服务体系"
  }else if(data.data === '399'){
     bannerValue.value = "深度整合与智能应用专业领域知识库资源，为高校教学和科研提供强大支持"
  }
});

const handleSearch = (data) => {
  keyWordIndex.value = data;
};
const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};

onMounted(() => {
  checkTokenStatus();

  searchQuery.value =
    route.query.keyword === undefined ? "" : route.query.keyword;
    currentBg.value = bannerzfbm;
});

onUnmounted(() => {
  bus.off("yyluid");
});

</script>

<style scoped>
.main-content-wrapper {
  width: 100%;
  position: relative; /* 确保子元素的定位基于此容器 */
background: #f2f2f2;
}

.content_box {
  width: 1400px;
  margin: 0 auto;
  background-color: #fff;
}

.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}

.main-conter {
  width: 100%;
  /* background-color: rgba(245, 245, 245, 1); */
  background: #f5f5f5;
  position: relative; /* 确保内容不会被遮挡 */
  z-index: 1; /* 确保内容在 header_box 之上 */
  /* padding-top: 24px; */
}

.header_box {
  width: 100%;
  height: 136px;
  background: linear-gradient(
    180deg,
    rgba(47, 97, 224, 0.09) 0%,
    rgba(31, 85, 222, 0) 100%
  );
  position: relative; /* 确保 header_box 的定位 */
  z-index: 0; /* 确保 header_box 在 main-conter 之下 */
}

.bannerbox {
  width: 100%;
  height: calc(438px - 164px);
  background-image: url(@/assets/headerimage/2know.png);
  display: flex;
  justify-content: left;
  background-size: cover;
  background-repeat: no-repeat; /* 禁止重复平铺 */
}

.banner_content {
  /* width: 1400px; */
  margin-left: 290px;
}

.banner_title {
  /* 可以根据需要添加标题样式 */
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 32px;
  color: #2c77ff;
  line-height: 45px;
  text-align: center;
  font-style: normal;
  margin-top: 41px;
}

.banner_text {
  /* 可以根据需要添加文本样式 */
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  line-height: 33px;
  text-align: left;
  padding-left: 150px;
  font-style: normal;
  padding-top: 83px;
}

.el-input {
  width: 402px;
  height: 40px;
  /* background: #ffffff; */
  border-radius: 6px;
  border: none;
  color: #ffffff;
}
.search-container {
  display: flex;
  justify-content: center;
  height: 88px;
  /* padding-top: 20px; */
}
.search-container :deep(.el-input-group__append) {
  border-left: 0;
  /* box-shadow: none !important; */
  width: 78px !important;
  background: #2c77ff !important;
  /* background-image: url(@/assets/headerimage/2inputbut.png);
  background-size: cover; */
  color: #ffffff !important;
  font-size: 18px;
  box-shadow: none;
  border-radius: 0;
}
.search-container :deep(.el-input__wrapper) {
  background: rgba(255, 255, 255, 0.21);
  /* box-shadow: none; */
  border-radius: 0;
}
.search-container :deep(.el-input__inner) {
  color: #333;
}
.content_box_header{
  width: 100%;
  /* height: 88px; */
  display: flex;
  justify-content: center;
  /* margin-top: 20px; */
  /* margin-bottom: 15px; */
}
.search_container_header{
  padding: 34px 0 29px 0;
  width: 1400px;
  /* background: #2c77ff; */
  text-align: center;
  font-size: 18px;
font-weight: 400;
color: #ffffff;
}
</style>
